import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import TVRetro from './icon-tv-retro.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <TVRetro {...validProps} />;
}
SvgComponent.iconName = 'browser';

/**
 * @deprecated This is a legacy icon
 */
export const TVRetroIcon = svgIconWrapper(SvgComponent);
